import { render, staticRenderFns } from "./AddonsFileTableById.vue?vue&type=template&id=51b2424e&"
import script from "./AddonsFileTableById.vue?vue&type=script&lang=js&"
export * from "./AddonsFileTableById.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports